import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import styles from './index.module.scss'

const MESSAGE_INTERVAL = 2800

const MESSAGES = {
  'synastry': [
    'Загружаем расчеты',
    'Почти готово',
  ],
  'daily': [
    'Анализируем день',
    'Формируем дейлик',
    'Почти готово',
  ],
  'natal-chart': [
    'Расчёт карты',
    'Позиции планет',
    'Анализ аспектов',
    'Почти готово',
  ],
  'matrix': [
    'Расчёт матрицы',
    'Анализ кармы',
    'Ключевые энергии',
    'Почти готово',
  ],
  'astro-synastry': [
    'Анализируем карты',
    'Точки притяжения',
    'Проверка red flags',
    'Сценарий пары',
    'Слабые места',
    'Почти готово',
  ],
  'matrix-monht': [
    'Расчёт матрицы',
    'Раскладка по месяцам',
    'Сверка с датой рождения',
    'Почти готово',
  ],
  'matrix-synastry': [
    'Расчёт совместимости',
    'Матрица пары',
    'Сценарий союза',
    'Энергия союза',
    'Слабые места',
    'Почти готово',
  ],
  'chat': [
    'Загружаем расчеты',
    'Загружаем сообщения',
    'Почти готово',
  ],
  'base': [
    'Загружаем расчеты',
    'Почти готово',
  ],
} as const

export const Loader:
  & FunctionalComponent<{
    type: keyof typeof MESSAGES
  }>
  & {
    Wrapper: FunctionalComponent
    Container: FunctionalComponent
    Dots: FunctionalComponent
  } = props => {
    const [messageIndex, setMessageIndex] = useState(0)

    useEffect(() => {
      const interval = setInterval(() => {
        setMessageIndex((prev) => (prev + 1) % MESSAGES[props.type].length)
      }, MESSAGE_INTERVAL)

      return () => clearInterval(interval)
    }, [])

    return (
      <div class={styles.root}>
        <div class={styles.logo}>
          ZoeAstro
        </div>

        <div class={styles.message} key={messageIndex}>
          {MESSAGES[props.type][messageIndex]}
          <Loader.Dots />
        </div>
      </div>
    )
  }

Loader.Wrapper = props => (
  <div class={classNames(styles.wrapper)}>
    {props.children}
  </div>
)

Loader.Container = props => (
  <div class={classNames(styles.container)}>
    {props.children}
  </div>
)

Loader.Dots = () => (
  <span class={styles.dots}>
    <span>.</span>
    <span>.</span>
    <span>.</span>
  </span>
)
